(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hby-base"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hby-tabs')) {
  customElements.define('hby-tabs', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const activate = (tab, focus = false) => {
        tabs.forEach(t => { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
        panels.forEach(p => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab), { signal: this.abort.signal });
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); activate(tabs[next], true);
        }, { signal: this.abort.signal });
      });
      this.addEventListener('shopify:block:select', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) activate(tab);
      }, { signal: this.abort.signal });
      if (tabs.length) activate(tabs[0]);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
if (!customElements.get('hby-calculator')) {
  customElements.define('hby-calculator', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const project = this.querySelector('[data-project]');
      const size = this.querySelector('[data-size]');
      const result = this.querySelector('[data-result]');
      const packResult = this.querySelector('[data-packs]');
      const update = () => {
        const option = project.selectedOptions[0];
        if (!option) { result.textContent = this.dataset.unavailable; packResult.textContent = ''; return; }
        [...size.options].forEach(o => { o.textContent = option.dataset[o.value + 'Label'] || o.value; });
        const amount = Math.ceil(Number(option.dataset[size.value]));
        if (!Number.isFinite(amount) || amount <= 0) { result.textContent = this.dataset.unavailable; packResult.textContent = ''; return; }
        const packSize = Math.max(1, Number(this.dataset.packSize) || 1);
        result.textContent = amount + ' ' + this.dataset.skeins;
        packResult.textContent = Math.ceil(amount / packSize) + ' ' + this.dataset.packs + ' × ' + packSize + ' ' + this.dataset.skeins;
      };
      project.addEventListener('change', update, { signal: this.abort.signal });
      size.addEventListener('change', update, { signal: this.abort.signal });
      update();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
if (!customElements.get('hby-navigation')) {
  customElements.define('hby-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const close = () => this.querySelectorAll('details[open]').forEach(d => { d.open = false; });
      document.addEventListener('click', event => { if (!this.contains(event.target)) close(); }, { signal: this.abort.signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]') || this.querySelector('details[open]');
        if (details) { details.open = false; details.querySelector('summary').focus(); }
      }, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        if (event.target.closest('a')) close();
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
